import { TextBody } from 'src/components/atoms';
import styled from 'styled-components';

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => 2 * theme.spacing()}px;
  padding: 0 ${({ theme }) => 2 * theme.spacing()}px
    ${({ theme }) => 2 * theme.spacing()}px;
`;

export const SectionLabel = styled(TextBody)`
  font-weight: 600;
  color: ${({ theme }) =>
    theme.isVaultVariant
      ? theme.newPalette.neutral.N1000
      : theme.atlas.semantic.color.type.default};
  margin-bottom: ${({ theme }) => theme.spacing()}px;
`;

export const CurrentCmRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => 1.5 * theme.spacing()}px;
  margin-bottom: ${({ theme }) => theme.spacing()}px;
`;

export const CurrentCmName = styled.span`
  font-weight: 500;
  color: ${({ theme }) =>
    theme.isVaultVariant
      ? theme.newPalette.neutral.N1000
      : theme.atlas.semantic.color.type.default};
`;

export const InstructionText = styled(TextBody)`
  color: ${({ theme }) =>
    theme.isVaultVariant
      ? theme.newPalette.neutral.N700
      : theme.atlas.semantic.color.type.muted};
  line-height: 1.4;
  width: 100%;
`;

export const ToggleBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing()}px;
`;

export const ToggleRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => 1.5 * theme.spacing()}px;
`;

export const ToggleLabel = styled.span`
  font-weight: 600;
  color: ${({ theme }) =>
    theme.isVaultVariant
      ? theme.newPalette.neutral.N1000
      : theme.atlas.semantic.color.type.default};
`;

export const DescriptionWithLink = styled(TextBody)`
  color: ${({ theme }) =>
    theme.isVaultVariant
      ? theme.newPalette.neutral.N700
      : theme.atlas.semantic.color.type.muted};
  line-height: 1.4;
`;

export const PickerSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing()}px;
`;

export const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: ${({ theme }) => 1.5 * theme.spacing()}px;
  padding: ${({ theme }) => 2 * theme.spacing()}px;
  border-top: 1px solid
    ${({ theme }) =>
      theme.isVaultVariant
        ? theme.newPalette.neutral.N300
        : theme.atlas.semantic.color.ui.divider.default};
`;

export const BannerWrap = styled.div`
  margin-top: ${({ theme }) => theme.spacing()}px;
`;
